import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Permissions, ProtectedPage } from 'carrier-fe';
import Installation from '../pages/view';
import Home from '../pages/home';
import React from "react";
import Register from '../pages/register';
import Lookup from '../pages/lookup';
import Review from '../pages/review';

function Router() {
	return (
		<BrowserRouter>
			<Routes>
				<Route
					index
					path="/"
					element={<Home />}
				/>
				<Route
					path='/register'
					element={<Register />}
				/>
				<Route
					path='/lookup'
					element={<Lookup />}
				/>
				<Route path='/installation'>
					<Route
						path=":installationId"
						element={
							// <ProtectedPage
							// 	requiredPermissions={Permissions.VIESSMANN_INSTALLATION_SHOW}
							// >
							<Installation />
							// </ProtectedPage>
						}
					/>

				</Route>
				<Route
					path='/review/:installationId'
					element={<Review />}
				/>

				{/* TODO - MAKE A PRETTY PAGE IN THE COMPONENT LIBRARY */}
				<Route
					path="*"
					element={<p>404</p>}
				/>
			</Routes>
		</BrowserRouter >
	);
}

export default Router;
